



























































































































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { NotificationProgrammatic as Notification } from "buefy";
export default Vue.extend({
  name: "ProductCampaignList",
  data() {
    return {
      selected: [],
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      file: null,
      upLoading: false,
      searchDebounce: null,
      exporting: false,
      randomPrizeDoing: false,
      importing: {}
    };
  },
  computed: {
    ...mapGetters({
      productCampaignList: "productCampaign/items",
      productCampaignLoading: "productCampaign/loading",
      productCampaignCount: "productCampaign/count"
    })
  },
  methods: {
    ...mapActions({
      deleteItemProductCampaign: "productCampaign/deleteItem",
      getFarmersCampaign: "farmerCampaign/filter",
      randomPrizeAction: "productCampaign/randomPrize",
      deleteFarmers: "productCampaign/deleteFarmers",
      importFarmerCampaign: "productCampaign/importFarmerCampaign",
      exportCSVLivestreamAct: "productCampaign/exportCSVLivestream",
      reducePoints: "productCampaign/reducePoints",
      getTaskInfo: "productCampaign/getTaskInfo",
      getTaskProgress: "productCampaign/getTaskProgress",
    }),
    ...mapMutations({
      setSelected: "productCampaign/setSelected",
      setItemEdit: "productCampaign/setItemEdit",
      showGetFarmersCampaign: "farmerCampaign/setListModal",
      setShowModalLivestream: "productCampaign/setShowModalLivestream",
      setCampaignOffline: "productCampaign/setCampaignOffline",
      setCloseDateModalId: "productCampaign/setCloseDateModalId",
      setCloseDateModal: "productCampaign/setCloseDateModal"
    }),
    handleViewStatus(taskId: string) {
      this.getTaskInfo(taskId);
    },
    handleReducePoints(id: string) {
      this.reducePoints(id);
    },
    async exportCSVLivestream(productCampaignId: string) {
      this.exporting = true;
      try {
        this.exportCSVLivestreamAct(productCampaignId);
        this.exporting = false;
      } catch (error) {
        this.exporting = false;
        console.log(error);
      }
    },
    async upload(id: string) {
      try {
        this.importing = {...this.importing, [id]: true}
        let res = await this.importFarmerCampaign({
          productCampaignId: id,
          file: this.file
        });
        this.checkProgress(res._id, id)
      } catch (error) {
        console.log(error.message);
      } finally {
        this.file = null
      }
    },
    async checkProgress(progressId: string, campaignId: string) {
      let res = await this.getTaskProgress(progressId)
      if (res.status == 'progress') {
        setTimeout(async () => {
          this.checkProgress(progressId, campaignId)
        }, 1000)
      } else if (res.status == 'failed') {
        Notification.open({
          duration: 3500,
          message: `${res.message}`,
          position: "is-top-right",
          type: "is-danger",
          hasIcon: true
        });
        this.importing = {...this.importing, [campaignId]: false}
      } else {
        Notification.open({
          duration: 3500,
          message: `Import thành công`,
          position: "is-top-right",
          type: "is-success",
          hasIcon: true
        });
        this.importing = {...this.importing, [campaignId]: false}
      }
    },
    async handleDeleteFarmer(productCampaignId: string) {
      try {
        await this.deleteFarmers(productCampaignId);
      } catch (error) {
        console.log(error);
      }
    },
    async handleCloseDate(id: string) {
      this.setCloseDateModalId(id)
      this.setCloseDateModal(true)
    },
    async handleCreateLivestream(id: string) {
      try {
        await this.randomPrizeAction(id);
      } catch (error) {
        console.log(error);
      }
    },
    handleGetFarmersCampaign(query: any) {
      this.getFarmersCampaign(query);
      this.showGetFarmersCampaign({ show: true });
    },
    handleShowModalLivestream(payload: any, query: any) {
      this.setCampaignOffline(payload);
      // this.getFarmersCampaign(query);
      this.setShowModalLivestream(true);
    },
    onPageChange() {},
    deleteProductCampaign(id: string) {
      this.deleteItemProductCampaign({
        idItem: id,
        textMess: "vòng quay"
      });
    },
    editProductCampaign(item: any) {
      this.setItemEdit(item);
      this.$router.push("/campaign/" + item.code);
    },
    testProductCampaign(id: string) {
      this.$router.push({ name: "campaignTest", params: { id: id } });
    },
    checked(e) {
      const listID = e.map(item => item._id);
      this.setSelected(listID);
    }
  }
});
